import { authorizationHeader } from 'lane-shared/helpers/formatters';
import makeFileDownload from './makeFileDownload';
import { GetAuthTokenResponse } from 'lane-shared/types/auth0/getAuthTokenResponseType';

export default async function downloadBulkFiles<TBody = any>(
  url: string,
  body: TBody,
  getAuthToken: GetAuthTokenResponse,
  customFilename?: string
) {
  const token = await getAuthToken();

  const response = await fetch(url, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: authorizationHeader(token),
    }),
    body: JSON.stringify(body),
  });

  const blob = await response.blob();
  const fileType = response.headers.get('content-type');
  const [, fileName] = (
    response.headers.get('content-disposition') || ''
  ).split('filename=');

  makeFileDownload({
    type: fileType || 'application/zip',
    name: customFilename || fileName || 'download.zip',
    blob,
  });
}
